import Highcharts from "highcharts/highcharts";
import _ from "lodash/lodash";
import ViewController from "core/views/view.controller";
import {Colors} from "main/main.config";


function dataLabelsFormatter() {
    return this.y > 0 ? this.y : '';
}

export default class ChartBookingProgressCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);
        this.chart = null;
        this.serviceCounts = {};

        // Bindings
        this.bookings = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    $onChanges(changes) {
        if (!changes.bookings) {
            return;
        }

        if (!changes.bookings.currentValue || !changes.bookings.currentValue.length) {
            this.bookings = [];
        }

        if (!this.chart) {
            this.createChart();
        }

        this.updateServiceCounts();
        this.updateChart();
    }

    updateChart() {
        let categories = [];
        let openCountData = [];
        let finishedCountData = [];

        _(this.serviceCounts).keys().sortBy(key => key.toLowerCase())
            .each(serviceName => {
                categories.push(serviceName);
                openCountData.push(this.serviceCounts[serviceName].open);
                finishedCountData.push(this.serviceCounts[serviceName].finished);
            });

        this.chart.xAxis[0].setCategories(categories);
        this.chart.series[0].setData(openCountData);
        this.chart.series[1].setData(finishedCountData);
        this.chart.setSize(null, null, false);
    }

    createChart() {
        this.chart = Highcharts.chart('chart-booking-services-hs', {
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 10,
                spacingLeft: 0,
                spacingRight: 0,
            },

            title: {
                text: ''
            },

            tooltip: {
                enabled: false
            },

            xAxis: {
                type: 'category',
                categories: [],
                labels: {
                    rotation: -45,
                    style: {
                        color: Colors.textNormal,
                        fontSize: '14px',
                        fontWeight: '400',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                    }
                }
            },

            yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                    text: ''
                },

                stackLabels: {
                    enabled: true,
                    style: {
                        color: Colors.textNormal,
                        fontSize: "14px",
                        fontWeight: '600',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                    }
                }
            },

            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        formatter: dataLabelsFormatter,
                        style: {
                            color: 'white',
                            fontSize: "14px",
                            fontWeight: '600',
                            fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif',
                            textShadow: null,
                            textOutline: null
                        }
                    }
                },

                series: {
                    enableMouseTracking: false
                }
            },

            legend: {
                enabled: true,
                itemStyle: {
                    color: Colors.textNormal,
                    fontSize: "14px",
                    fontWeight: '400',
                    fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                }
            },

            series: [{
                name: 'Offen',
                data: [0],
                color: Colors.bg
            }, {
                name: 'Erledigt',
                data: [0],
                color: Colors.highlight1
            }]
        });
    }

    updateServiceCounts() {
        this.serviceCounts = {};

        _(this.bookings)
            .groupBy(booking => {
                return booking.service != null ? booking.service.name : 'Ohne';
            })
            .each((bookings, serviceName) => {
                this.serviceCounts[serviceName] = {
                    open: 0,
                    finished: 0
                };

                bookings.forEach((booking)=> {
                    if (booking.isOpen()) {
                        this.serviceCounts[serviceName].open++;
                    } else {
                        this.serviceCounts[serviceName].finished++;
                    }
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-services/chart-booking-services.controller.js